const modules = import.meta.glob('./*/*.ts', { eager: true });

const messages: Record<string, { home: Record<string, string> }> = {};

Object.keys(modules).forEach((path) => {
  const match = path.match(/\.\/([^/]+)\/([^/]+)\.ts$/);
  if (match) {
    const [, lang] = match;
    const module = modules[path] as Record<string, any>;

    if (!messages[lang]) {
      messages[lang] = { home: {} };
    }

    // 翻译文件用 export const home = {...} 导出，需要读取命名导出
    const translations = module.default || module.home;
    if (translations) {
      messages[lang].home = {
        ...messages[lang].home,
        ...translations
      };
    }
  }
});

export default messages;